import React, { useEffect, useRef, useState } from "react";
import { object, array, string, bool } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { LazyCollection } from "@quintype/components";

import { getCollectionTemplate } from "../get-collection-template";

import Navbar from "../layouts/header/Navbar";
import HamburgerIcon from "../atoms/icons/hamburger";
import { setVerticalMenuBar, setMobileFilter } from "../helper/actions";
import { useDeviceWidth, logoRenderer } from "../utils/react-utils";
import { micrositeStyles } from "../layouts/header/NewHeader/header-utils";
import MobileLogo from "../atoms/MobileLogo";
import SearchIcon from "../atoms/icons/search-icon";
import NavbarSearch from "../layouts/header/NavbarSearch";
import VerticalMenubar from "../layouts/header/VerticalMenubar";

import "./home.m.css";

const HomePageBase = ({
  data,
  domainMenuItemsObj,
  isVerticalMenubar,
  currentPath,
  domainSlug,
  publisherAttributes,
}) => {
  const scrollRef = useRef(null);
  const ref = useRef(null);
  const [sticky, setSticky] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [domainStyle, setDomainStyle] = useState({});
  const [showSearchIcon, setShowSearchIcon] = useState(true);
  const [multiDomainClass, setmultiDomainClass] = useState("");
  const [verticalMenu, setVerticalMenu] = useState(false);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowSearchIcon(true);
    }
  };
  useDeviceWidth(setIsDesktop);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    document.addEventListener("scroll", () => setShowSearchIcon(true));
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      document.addEventListener("scroll", () => setShowSearchIcon(true));
    };
  });

  useEffect(() => {
    if (global.deviceWidth > 876) {
      const headerElement = global.document.getElementById("header");
      headerElement.style.cssText = "position: static";

      return () => (headerElement.style.cssText = "position: sticky");
    }
  }, []);

  useEffect(() => {
    if (verticalMenu) {
      global.document.body.style.overflow = "hidden";
    } else {
      global.document.body.style.cssText = "overflow-x: hidden, overflow-y: auto";
    }
  }, [verticalMenu]);

  useEffect(() => {
    if (domainSlug) {
      setDomainStyle(micrositeStyles[domainSlug] || {});
    }

    if ((domainSlug === "protichinta" || domainSlug === "kishoralo") && sticky) {
      setmultiDomainClass(`${domainSlug}-sticky-navbar`);
    } else if ((domainSlug === "protichinta" || domainSlug === "kishoralo") && !sticky) {
      setmultiDomainClass(`${domainSlug}-navbar`);
    } else if (domainSlug === "trust" && sticky) {
      setmultiDomainClass("trust-sticky-navbar");
    }
  }, [domainSlug, sticky]);

  const menuItemsObject =
    domainMenuItemsObj.length > 0
      ? {
          homePageMenuItems: domainMenuItemsObj.find((item) => item.title === "home" || item.title === "Home"),
          hamburgerMenuItems: domainMenuItemsObj.find((item) => item.title === "hamburger"),
        }
      : null;

  const homePageMenuItems = get(menuItemsObject, ["homePageMenuItems", "children"], []);
  const hamburgerMenu = get(menuItemsObject, ["hamburgerMenuItems", "children"], []);

  useEffect(() => {
    const handleScroll = () => {
      const navbarTopDistance = scrollRef.current.getBoundingClientRect().top;
      navbarTopDistance > 0 ? setSticky(false) : setSticky(true);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.addEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    !showSearchIcon && toggleSearchIcon();
  }, [sticky]);

  const toggleVerticalMenubar = () => {
    setVerticalMenu(!verticalMenu);
    setMobileFilter(false);
  };

  const toggleSearchIcon = () => setShowSearchIcon(!showSearchIcon);

  const navbarColor = sticky ? domainStyle.navbarStickyColor : domainStyle.navbarBgColor;
  const menuItemsColor = sticky ? domainStyle.stickyMenuStyle : domainStyle.menuStyle;

  return (
    <>
      <div
        styleName={`${sticky ? "sticky-navbar navbar" : "navbar"} ${multiDomainClass}`}
        ref={scrollRef}
        style={{ backgroundColor: navbarColor }}
      >
        <div styleName="hamburger-search-wrapper" className="hamburger-search-wrapper">
          <div styleName="search-ham" className="search-ham">
            {(!verticalMenu || (isDesktop && sticky)) && !currentPath && (
              <HamburgerIcon
                onMenuToggle={toggleVerticalMenubar}
                isNavbarOpen={!!isVerticalMenubar}
                isDesktop={isDesktop}
                hamburgerStyle={{ backgroundColor: domainStyle.hamburgerStickyColor }}
              />
            )}
            {domainSlug === "protichinta" && (
              <>
                <div styleName={`logo ${isVerticalMenubar ? "vertical-menu-bar-logo" : ""}`}>
                  {logoRenderer(<MobileLogo />, currentPath)}
                </div>
              </>
            )}
            {showSearchIcon && domainSlug !== "protichinta" && (
              <span styleName="search-icon" onClick={toggleSearchIcon}>
                <SearchIcon color={domainStyle.searchStickyColor} />
              </span>
            )}
            {domainSlug !== "protichinta" && (
              <>
                <span ref={ref}>{!showSearchIcon && <NavbarSearch publisherAttributes={publisherAttributes} />}</span>
                <div styleName="nav-logo">{logoRenderer(<MobileLogo editLogo={true} />, currentPath)}</div>
              </>
            )}
          </div>
        </div>
        <Navbar
          menu={homePageMenuItems.slice(0, 12)}
          navbarMenuStyle={{ color: menuItemsColor }}
          domainSlug={domainSlug}
          lang={publisherAttributes.lang}
        />

        {verticalMenu ? (
          <VerticalMenubar
            isVerticalMenubar={verticalMenu}
            isDesktop={isDesktop}
            toggleVerticalMenubar={toggleVerticalMenubar}
            hamburgerMenu={hamburgerMenu}
            domainSlug={domainSlug}
          />
        ) : null}
      </div>
      <div styleName="home-wrapper">
        <div styleName="collection-container">
          {data.collection && (
            <LazyCollection
              liveBlogStory={data.liveBlogStory}
              collection={data.collection}
              collectionTemplates={getCollectionTemplate}
              lazyAfter={1}
              mostCommentedStories={data.mostCommentedStories}
            />
          )}
        </div>
      </div>
    </>
  );
};

HomePageBase.propTypes = {
  data: object,
  domainMenuItemsObj: array,
  pageType: string,
  isVerticalMenubar: bool,
  currentPath: string,
  domainSlug: string,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  pageType: get(state, ["qt", "pageType"], ""),
  menu: get(state, ["qt", "data", "navigationMenu"], []),
  domainMenuItemsObj: get(state, ["qt", "data", "navigationMenu", "menuItems"], []),
  isVerticalMenubar: get(state, ["settingsReducer", "isVerticalMenubar"], false),
  currentPath: get(state, ["currentPathReducer", "currentPath"], null),
  domainSlug: get(state, ["qt", "domainSlug"]),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

const mapDispatchToProps = (dispatch) => ({
  setVerticalMenuBar: (flag) => dispatch(setVerticalMenuBar(flag)),
  setMobileFilter: (flag) => dispatch(setMobileFilter(flag)),
});

export const HomePage = connect(mapStateToProps, mapDispatchToProps)(HomePageBase);
